import PropTypes from 'prop-types'
import { baseSlicePropTypes } from '../slice.types'

/**
 * @typedef {Object} ThirdPartyBilling
 * @property {string} nickname
 * @property {string} carrier
 * @property {string} account
 * @property {string} zip_code
 * @property {string} country_code
 */

/**
 * @typedef {Object} ThirdPartyBillingsSlice
 * @extends {import('../slice.types').BaseSlice}
 * @property {ThirdPartyBilling[]} data
 */

export const THIRD_PARTY_BILLINGS_ACTIONS = {
  SET_THIRD_PARTY_BILLINGS: 'SET_THIRD_PARTY_BILLINGS',
  SET_STATUS: 'SET_THIRD_PARTY_BILLINGS_STATUS',
  SET_ERRORS: 'SET_THIRD_PARTY_BILLINGS_ERRORS',
  CLEAR_ERRORS: 'CLEAR_THIRD_PARTY_BILLINGS_ERRORS'
}

export const initialThirdPartyBillingsState = {
  status: 'idle',
  errors: [],
  data: []
}

export const thirdPartyBillingsPropTypes = {
  ...baseSlicePropTypes,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      nickname: PropTypes.string,
      carrier: PropTypes.string,
      account: PropTypes.string,
      zip_code: PropTypes.string,
      country_code: PropTypes.string
    })
  )
}
